__turbopack_context__.v({
  "already-returned-wrapper": "return-module-scss-module__So7Q-W__already-returned-wrapper",
  "button": "return-module-scss-module__So7Q-W__button",
  "buttons-container": "return-module-scss-module__So7Q-W__buttons-container",
  "buttons-toggle-container": "return-module-scss-module__So7Q-W__buttons-toggle-container",
  "product-item-placeholder": "return-module-scss-module__So7Q-W__product-item-placeholder",
});
